import React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import ClipLoader from 'react-spinners/ClipLoader';

import { ListSettingsNaviList } from '../components/list/ListSettingsNaviList';
import { Confirmation } from '../components/modals/common';
import { DndTable, DragTableItem } from '../components/ListSettingDndTableItem';

import { CompanyBranchService } from '../services/CompanyBranches';

import masterSlideLoader from '../utilities/masterSlideLoader';

import {
  HEADER_CONSTANTS, // ヘッダータイトル
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility'; // ユーザー情報API
import { MasterPageHeader } from '../components/PageHeader';
import { QuestionIcon } from '../components/icons/QuestionIcon';
import Tippy from '../components/ReactTippy';
import { Description } from '../components/Description';

/**
 * 会社情報確認 画面
 *  元請用
 * 画面遷移
 *  - 本社管理者でログイン > 会社情報確認 > 編集ボタン
 */
export class ListSettingsEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      companyBranchId: null,
      companyBranch: {},
      branchLoaded: false,
      showConfirmDialog: false,
      showGoBackDialog: false,
      validate: {
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },

      listItems: [],
      work_columns_settings: {
        conference_order: [],
        list_order: [],
      },
    };

    this.submitRef = React.createRef(); // 登録ボタン要素

    // イベント登録
    this.events = {
      dialog: {
        showConfirmDialog: this.showConfirmDialog.bind(this),
        closeConfirmDialog: this.closeConfirmDialog.bind(this),
        showGoBackDialog: this.showGoBackDialog.bind(this),
        closeGoBackDialog: this.closeGoBackDialog.bind(this),
      },
      goBack: this.goBack.bind(this), // 閉じる
      update: this.update.bind(this),
      handleReset: this.handleReset.bind(this),
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const companyBranchId = this.props.view.state.id;
    this.getBranchInfo(companyBranchId);
    this.getWorkColumnsSettings(companyBranchId);
  }

  getBranchInfo = id => {
    CompanyBranchService.showBranch(id).then(response => {
      if (response.result === false) {
        return;
      } else {
        const data = response.data.entities.company_branch;
        this.setState({
          branchLoaded: true,
          companyBranch: data,
        });
      }
    });
  };

  handleReset = () => {
    const companyBranchId = this.state.companyBranch.id;
    const param = {
      default: Number(1),
    };
    this.getWorkColumnsSettings(companyBranchId, param);
  };

  getWorkColumnsSettings = (id, param) => {
    CompanyBranchService.workColumnsSettings(id, param).then(response => {
      if (response.result === false) {
        return;
      } else {
        const data = response.data.entities.work_columns_settings;

        const editableList = _.map(
          _.sortBy(
            _.filter(data.list_order, item => {
              return item.editable;
            }),
            'order_number'
          ),
          listItem => {
            return {
              name: listItem.name,
              type: listItem.type,
              list_display: listItem.display,
            };
          }
        );
        const constraintItems = ['foreman_user_name', 'job_name', 'company_name', 'work_date'];
        const statusDefaultItems = []
        let finishedList = _.map(editableList, (listItem, index) => {
          const conferenceItem = _.find(data.conference_order, conf_item => {
            return conf_item.type === listItem.type;
          });
          const multipleEditItem = _.find(
            data.edit_multiple_order,
            conf_item => {
              return conf_item.type === listItem.type;
            }
          );
          if (_.includes(constraintItems, multipleEditItem.type)) {
            statusDefaultItems.push({type_name: multipleEditItem.type, index})
          }
          return {
            name: listItem.name,
            type: listItem.type,
            list_display: listItem.list_display,
            conference_display: conferenceItem.display,
            conference_edit_editable: conferenceItem.editable,
            multiple_edit_display: multipleEditItem.display,
            multiple_edit_editable: multipleEditItem.editable,
          };
        });
        _.forEach(statusDefaultItems, item => {
          finishedList = this.handleCheckItemConstraint(
            finishedList,
            item.index,
            item.type_name,
            'multiple_edit_display'
          );
        })
        this.setState(
          {
            listItems: finishedList,
            work_columns_settings: response.data.entities.work_columns_settings,
          },
          () => {
            this.validateAll();
          }
        );
      }
    });
  };

  async update() {
    const list = _.map(this.state.listItems, item => {
      return {
        type: item.type,
        display: item.list_display,
      };
    });
    const conference = _.map(this.state.listItems, item => {
      return {
        type: item.type,
        display: item.conference_display,
      };
    });
    const editMultiple = _.map(this.state.listItems, item => {
      return {
        type: item.type,
        display: item.multiple_edit_display,
      };
    });
    const output = {
      id: this.state.companyBranch.id,
      list,
      conference,
      edit_multiple: editMultiple,
    };

    CompanyBranchService.updateWorkColumnsSettings(
      this.state.companyBranch.id,
      output
    ).then(response => {
      if (response.result === false) {
        return;
      } else {
        this.setState(
          {
            showConfirmDialog: false,
          },
          () => {
            this.submitRef.current.disabled = false;
            masterSlideLoader.show('ListSettingsPreview', {
              state: { id: this.state.companyBranch.id },
            });
          }
        );
      }
    });
  }

  moveItem = (dragIndex, hoverIndex) => {
    const { listItems } = _.cloneDeep(this.state);
    const dragItem = listItems[dragIndex];

    listItems.splice(dragIndex, 1);
    listItems.splice(hoverIndex, 0, dragItem);

    this.setState({
      listItems,
    });
  };

  getItemByTypeName = (listItems, typeName) => {
    return _.get(_.find(listItems, item => item.type === typeName), 'name');
  }

  getColumnConstraintName = (listItems, typeName)=> {
    let columnConstraint;
    switch (typeName) {
      case 'company_name':
        columnConstraint = this.getItemByTypeName(listItems, 'work_date');
        break;
      case 'job_name':
        columnConstraint = this.getItemByTypeName(listItems, 'company_name');
        break;
      case 'foreman_user_name':
        columnConstraint = this.getItemByTypeName(listItems, 'job_name');
        break;
      case 'manager_user_name':
        columnConstraint = this.getItemByTypeName(listItems, 'work_date');
        break;
      case 'key_plan_name':
        columnConstraint = this.getItemByTypeName(
          listItems,
          'foreman_user_name'
        );
        break;
      default:
        return null;
    }
    return columnConstraint;
  }

  handleCheckItemConstraint = (listItems, itemIndex, itemType, listType) => {
    const checkItemKeys = {
      work_date: [
        'company_name',
        'job_name',
        'foreman_user_name',
        'manager_user_name',
        'key_plan_name',
      ],
      company_name: ['job_name', 'foreman_user_name'],
      job_name: ['foreman_user_name'],
      foreman_user_name: ['key_plan_name'],
    };
    const unCheckItemKeys = {
      work_date: ['company_name', 'manager_user_name'],
      company_name: ['job_name'],
      job_name: ['foreman_user_name'],
      foreman_user_name: ['key_plan_name'],
    };
    const relationKeys = listItems[itemIndex][listType]
      ? checkItemKeys[itemType]
      : unCheckItemKeys[itemType];
    if (!_.isEmpty(relationKeys)) {
      _.forEach(listItems, item => {
        if (relationKeys.includes(item.type)) {
          if (listItems[itemIndex][listType]) {
            item[listType] =
            listItems[itemIndex][listType];
            item.columnConstraint = this.getColumnConstraintName(listItems, item.type);
          } else {
            item.columnConstraint = null;
          }
        }
      });
    }
    return listItems;
  }

  handleInputChange = event => {
    let { listItems } = _.cloneDeep(this.state);
    const itemNode = _.split(event.target.name, '--', 2);
    const itemMode = itemNode[0];
    const itemType = itemNode[1];
    const itemIndex = _.findIndex(listItems, { type: itemType });
    if (itemMode === 'list') {
      //通常モード
      listItems[itemIndex].list_display = !listItems[itemIndex].list_display;
    } else if (itemMode === 'conf') {
      //会議モード
      listItems[itemIndex].conference_display = !listItems[itemIndex]
        .conference_display;
    } else if (itemMode === 'multiple-edit') {
      //一括編集モード
      listItems[itemIndex].multiple_edit_display = !listItems[itemIndex]
        .multiple_edit_display;
      listItems = this.handleCheckItemConstraint(
        listItems,
        itemIndex,
        itemType,
        'multiple_edit_display'
      );
    }
    this.setState({ listItems }, () => {
      this.validateAll();
    });
  };

  validateAll() {
    const { listItems } = this.state;
    let result;
    if (
      _.some(listItems, { list_display: true }) &&
      _.some(listItems, { conference_display: true })
    ) {
      result = true;
    } else {
      result = false;
    }
    this.setState(
      {
        validate: {
          ...this.state.validate,
          invalid: !result,
        },
      },
      () => {
        return result;
      }
    );
  }

  showConfirmDialog = () => {
    this.submitRef.current.disabled = true;
    if (this.validateAll() === false) {
      this.submitRef.current.disabled = false;
      return;
    }

    this.setState({
      showConfirmDialog: true,
    });
  };

  closeConfirmDialog = () => {
    this.setState(
      {
        showConfirmDialog: false,
      },
      () => {
        this.submitRef.current.disabled = false;
      }
    );
  };

  showGoBackDialog = () => {
    this.setState({
      showGoBackDialog: true,
    });
  };

  closeGoBackDialog = () => {
    this.setState({
      showGoBackDialog: false,
    });
  };

  // 戻るダイアログ
  goBack = () => {
    masterSlideLoader.show('ListSettingsPreview', {
      state: { id: this.state.companyBranch.id },
    });
  };

  render() {
    const { branchLoaded, companyBranch } = this.state;
    return (
      <React.Fragment>
        <div id='slide-view' className='contruction-slide-view show'>
          <Helmet>
            <title>{HEADER_CONSTANTS.title} - 一覧表示設定</title>
          </Helmet>
          <div className='contruction-slide-view__view'>
            <MasterPageHeader
              title={'一覧表示設定'}
              onClose={() => this.events.dialog.showGoBackDialog()}
            />
            <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
              <div className='contruction-detail-view'>
                <div className='contruction-detail-view__sidemenu'>
                  <ListSettingsNaviList />
                </div>
                <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                  <div className='contruction-detail-view__menu list-settings-menu'>
                    <span className='construction-detail-view__button'>
                      <button
                        className='btn--sub'
                        onClick={() => this.events.dialog.showGoBackDialog()}
                      >
                        編集をやめる
                      </button>
                    </span>
                    <span className='construction-detail-view__button'>
                      <button
                        className={
                          this.state.validate.invalid
                            ? 'btn--effective btn--disabled'
                            : 'btn--effective'
                        }
                        onClick={() => {
                          this.events.dialog.showConfirmDialog();
                        }}
                        ref={this.submitRef}
                      >
                        更新
                      </button>
                    </span>
                    {branchLoaded ? (
                      <span className=''>支店：{companyBranch.name}</span>
                    ) : (
                      <React.Fragment>
                        <span className=''>支店：</span>
                        <ClipLoader size={20} color={'#EDB715'} />
                      </React.Fragment>
                    )}
                  </div>
                  <div className='contruction-detail-view__bar' />
                  <div className='contruction-detail-view__main contruction-detail-view__main--fixed list-settings'>
                    <div className='list-settings-message'>
                      <Description>
                        <p>
                          作業予定一覧・作業実績一覧で表示する項目、および一括編集を許可する項目の選択と並べ替えが設定できます。
                        </p>
                        <p>
                          設定は支店単位になります。支店内の全現場に即時反映されますのでご注意ください。
                        </p>
                        <p>
                          なお、現場ごとの項目設定で設定した内容はこのページの設定より優先されます。
                        </p>
                      </Description>
                    </div>
                    {this.state.validate.invalid && (
                      <span className='list-settings-error'>
                        {messageUtility.getMessage('I-000-089')}
                      </span>
                    )}
                    <div className='list-settings-submenu'>
                      <button
                        className='list-settings-menu__button btn--text'
                        onClick={this.events.handleReset}
                      >
                        デフォルトの設定に戻す
                      </button>
                    </div>
                    <div className='list-settings-table'>
                      <div className='list-settings-table__header'>
                        <div className='list-settings-table-cell list-settings-table-item__icon' />
                        <div className='list-settings-table-cell list-settings-table-item__name'>
                          <Tippy
                            duration={10}
                            distance={24}
                            arrow='true'
                            arrowType='sharp'
                            delay={[500, 500]}
                            placement='bottom'
                            followCursor={true}
                            html={
                              <div className={'tippy-tooltip'}>
                                ドラック＆ドロップで表示する項目の順番を並べ替えることができます。
                                <br />
                                上の項目ほど一覧の左側に表示されます。
                              </div>
                            }
                          >
                            <div className='list-settings-table__header-title'>
                              <div className='list-settings-table__header-title-text'>
                                項目名
                              </div>
                              <QuestionIcon
                                className={'icon--2x question-icon'}
                              />
                            </div>
                          </Tippy>
                        </div>
                        <div className='list-settings-table-cell list-settings-table-item__list-display'>
                          <Tippy
                            duration={10}
                            distance={24}
                            arrow='true'
                            arrowType='sharp'
                            delay={[500, 500]}
                            placement='bottom'
                            followCursor={true}
                            html={
                              <div className={'tippy-tooltip'}>
                                作業予定一覧・作業実績一覧の通常モードで
                                <br />
                                表示したい項目にチェックを入れてください。
                              </div>
                            }
                          >
                            <div className='list-settings-table__header-title'>
                              <div className='list-settings-table__header-title-text'>
                                通常モード表示
                              </div>
                              <QuestionIcon
                                className={'icon--2x question-icon'}
                              />
                            </div>
                          </Tippy>
                        </div>
                        <div className='list-settings-table-cell list-settings-table-item__conference-display'>
                          <Tippy
                            duration={10}
                            distance={24}
                            arrow='true'
                            arrowType='sharp'
                            delay={[500, 500]}
                            placement='bottom'
                            followCursor={true}
                            html={
                              <div className={'tippy-tooltip'}>
                                作業予定一覧・作業実績一覧の会議モードで
                                <br />
                                表示したい項目にチェックを入れてください。
                              </div>
                            }
                          >
                            <div className='list-settings-table__header-title'>
                              <div className='list-settings-table__header-title-text'>
                                会議モード表示
                              </div>
                              <QuestionIcon
                                className={'icon--2x question-icon'}
                              />
                            </div>
                          </Tippy>
                        </div>
                        <div className='list-settings-table-cell list-settings-table-item__multiple-edit-display'>
                          <Tippy
                            duration={10}
                            distance={24}
                            arrow='true'
                            arrowType='sharp'
                            delay={[500, 500]}
                            placement='bottom'
                            followCursor={true}
                            html={
                              <div className={'tippy-tooltip'}>
                                一括編集を許可する項目にチェックを入れてください。
                              </div>
                            }
                          >
                            <div className='list-settings-table__header-title'>
                              <div className='list-settings-table__header-title-text'>
                                一括編集を許可
                              </div>
                              <QuestionIcon
                                className={'icon--2x question-icon'}
                              />
                            </div>
                          </Tippy>
                        </div>
                      </div>
                      <DndTable>
                        {this.state.listItems.map((item, i) => (
                          <DragTableItem
                            key={i}
                            index={i}
                            id={item.type}
                            name={item.name}
                            type={item.type}
                            moveItem={this.moveItem}
                            conferenceDisplay={item.conference_display}
                            conferenceEditEditable={
                              item.conference_edit_editable
                            }
                            listDisplay={item.list_display}
                            handleInputChange={this.handleInputChange}
                            multipleEditDisplay={item.multiple_edit_display}
                            multipleEditEditable={item.multiple_edit_editable}
                            columnConstraint={item.columnConstraint}
                          />
                        ))}
                      </DndTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Confirmation
            title={`設定の更新`}
            visible={this.state.showConfirmDialog}
            confirmButtonText={messageUtility.getMessage('I-000-088')}
            cancelButtonText={messageUtility.getMessage('I-000-008')}
            message={messageUtility.getMessage('I-000-087')}
            isNegative={false}
            onCancel={this.events.dialog.closeConfirmDialog}
            onConfirm={this.events.update}
          />
          <Confirmation
            title={`編集画面を閉じる`}
            visible={this.state.showGoBackDialog}
            confirmButtonText={messageUtility.getMessage('I-000-025')}
            cancelButtonText={messageUtility.getMessage('I-000-008')}
            message={messageUtility.getMessage('I-000-050')}
            isNegative={true}
            onCancel={this.events.dialog.closeGoBackDialog}
            onConfirm={this.events.goBack}
          />
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ListSettingsEdit.jsx